import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { Form as bootStrapForm, Button, Spinner, Overlay, Popover } from 'react-bootstrap';
import CyberSecurity from '../../../../../../apis/cyberSecurityData';
import * as yup from 'yup';

const schema = yup.object({
    email: yup.string().max(50).matches(/^[ A-Za-z0-9_.@&',-\/()]*$/, 'Please enter a valid Email Address').email('Please enter a valid Email Address')
});

const InvitePeople = ({ board }) => {
    //redux store state
    const currentUser = useSelector(state => state.currentUser);
    const accessToken = useSelector(state => state.accessToken);
    // comp state
    const [submitting, setSubmitting] = useState(false);
    const [copied, setCopied] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = useRef(null);

    const userMadeInvite = currentUser.firstName + ' ' + currentUser.lastName;
    const boardLink = encodeURI(`${process.env.REACT_APP_TRUKNO_BASE_URL}/joinboard?boardId=${board._id}&boardName=${board.name}&userMadeInvite=${userMadeInvite}`);

    const renderTextField = ({ field, form, meta, checkHidden }, label) => {
        return (
            <bootStrapForm.Group>
                {/* <bootStrapForm.Label>{label}</bootStrapForm.Label> */}
                <bootStrapForm.Control isInvalid={meta.touched && meta.error} {...field} type="text" placeholder={label} />
                {meta.touched && meta.error && <div className="error" style={{ color: '#ff4040' }}>{meta.error}</div>}
            </bootStrapForm.Group>
        )
    }

    const onCopyClick = (event) => {
        setCopied(true)
        setTarget(event.target);
        navigator.clipboard.writeText(boardLink)
        setTimeout(() => {
            setCopied(false)
        }, 1000);
    }

    return (
        <Formik
            validationSchema={schema}
            // validate={values => validate(values)}
            onSubmit={async (values, { resetForm, setErrors }) => {
                if (values.email.toLowerCase() === currentUser.email.toLowerCase()) return setErrors({ email: "you can't invite yourself" });

                if (board.membersData.length > 0) {
                    const isMember = board.membersData.filter(member => member.email === values.email);
                    if (isMember.length > 0) return setErrors({ email: "Already a member" });
                    if (board.ownerData[0].email === values.email) return setErrors({ email: "Already a member" });
                }

                if (values.email) {
                    const data = {
                        email: values.email,
                        boardId: board._id,
                        boardName: board.name,
                        link: boardLink
                    }

                    const response = await CyberSecurity.post('/boardinvite', data, {
                        headers: {
                            Authorization: `Bearer ${accessToken}`
                        }
                    });

                    resetForm();
                } else {
                    return setErrors({ email: "Please enter email" })
                }
            }}
            initialValues={{
                email: '',
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                validateField,
                isSubmitting
            }) => (
                    <Form autoComplete="off">
                        <div className="row mb-4 mx-3">
                            <div className="col-md-12 pr-md-2">
                                <label className="mb-1 form-label">Invitation Link</label>
                                <div className="link-container d-flex justify-content-between">
                                    <span className="m-0 pr-3 text-blue pointer">{boardLink}</span>
                                    <div className="m-0 p-0" ref={ref}>
                                        <span className="material-icons pointer text-light-grey" onClick={onCopyClick}>content_copy</span>

                                        <Overlay
                                            show={copied}
                                            target={target}
                                            placement="left"
                                            container={ref.current}
                                            containerPadding={20}
                                        >
                                            <Popover id="popover-contained">
                                                <p className="p-2">Copied to clipboard</p>
                                            </Popover>
                                        </Overlay>
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div className="row mx-3">
                            <div className="col-md-12 pr-md-2">
                                <label className="mb-1">Send mail Invitation</label>
                                <Field name="email">
                                    {({ field, form, meta }) => renderTextField({ field, form, meta }, 'Email*')}
                                </Field>
                            </div>
                        </div>

                        <div className="d-flex flex-column justify-content-center  align-items-center pb-4">

                            <Button variant="primary" type="submit" size="lg" className="mt-4">
                                Submit
                                {submitting ? <Spinner className="ml-3" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                            </Button>
                        </div>
                    </Form>
                )}
        </Formik>
    )
}

export default InvitePeople
